module.exports = __webpack_public_path__ + "static/fonts/iconfont.f3a64f1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.eot?t=1683809780211
// module id = UT57
// module chunks = 44